module.exports = __webpack_public_path__ + "static/media/powered-by-vercel.5e94d026.svg";